import { render, staticRenderFns } from "./SdcManagement.vue?vue&type=template&id=baa92512&scoped=true&"
import script from "./SdcManagement.vue?vue&type=script&lang=js&"
export * from "./SdcManagement.vue?vue&type=script&lang=js&"
import style0 from "./SdcManagement.vue?vue&type=style&index=0&id=baa92512&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa92512",
  null
  
)

export default component.exports